  <!-- <div class="content" [hidden]="selectedTabLabel!='Dateiaustausch'">
    <div class="splitter">
      <div class="splitterleft" *ngIf="selectedTabLabel=='Dateiaustausch'">
        <app-files #filescomp *ngIf="activeProjectService.project" [clientHeight]="clientHeight" [folder]="'download'" [title]="'Download'"></app-files>
      </div>
      <div class="splitterright" *ngIf="selectedTabLabel=='Dateiaustausch' || runningUploadsCount>0">
        <app-files *ngIf="activeProjectService.project" [clientHeight]="clientHeight" [folder]="'upload'" [title]="'Upload'" [isUploadAllowed]="true"
          (setCountRunningUploads)="onSetCountRunningUploads($event)"></app-files>
      </div>
    </div>
  </div> -->
  <div class="main-content">
    <div class="container-fluid">

      <div class="card sq-card">

        <div class="card-header card-header-squirrel">
          <div>
            <h4>Dateidownload</h4>             
          </div>
        <div class="clearfix"></div>
      </div>

      <div class="card-body">

        <div class="content" >
          <div class="splitter">
            <div class="splitterleft" >
              <app-files #filescomp [clientHeight]="clientHeight" [folder]="'download'" [title]="'Download'" [userEmail]="ownUserEmail" >

              </app-files>
            </div>
            <!-- <div class="splitterright" >
              <app-files [clientHeight]="clientHeight" [folder]="'upload'" [title]="'Upload'" [isUploadAllowed]="true">
              </app-files>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
